import { render } from "./UserReinviteView.vue?vue&type=template&id=81005604&scoped=true"
import script from "./UserReinviteView.vue?vue&type=script&lang=js"
export * from "./UserReinviteView.vue?vue&type=script&lang=js"

import "./UserReinviteView.vue?vue&type=style&index=0&id=81005604&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81005604"]])

export default __exports__